// Normalize FastAPI / axios error responses into a user-friendly string.
// Handles: plain string detail, Pydantic validation arrays, network errors.
export function apiErrorMessage(error, fallback = 'Errore imprevisto') {
    const detail = error?.response?.data?.detail;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((d) => {
                if (typeof d === 'string') return d;
                const field = Array.isArray(d?.loc) ? d.loc.filter((x) => x !== 'body').join('.') : '';
                const msg = d?.msg || 'campo non valido';
                return field ? `${field}: ${msg}` : msg;
            })
            .join(' · ');
    }
    if (detail && typeof detail === 'object') {
        try { return JSON.stringify(detail); } catch { /* noop */ }
    }
    if (error?.message) return error.message;
    return fallback;
}
